var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.35 93.73",
    style: {
      enableBackground: "new 0 0 100.35 93.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#A3195B;}\n\t.st4{fill:#0F6285;}\n\t.st5{fill:#E94B3D;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:url(#SVGID_9_);}\n\t.st12{fill:url(#SVGID_10_);}\n\t.st13{fill:url(#SVGID_11_);}\n\t.st14{fill:url(#SVGID_12_);}\n\t.st15{fill:url(#SVGID_13_);}\n\t.st16{fill:url(#SVGID_14_);}\n\t.st17{fill:url(#SVGID_15_);}\n\t.st18{fill:url(#SVGID_16_);}\n\t.st19{fill:url(#SVGID_17_);}\n\t.st20{fill:url(#SVGID_18_);}\n\t.st21{fill:url(#SVGID_19_);}\n\t.st22{fill:url(#SVGID_20_);}\n\t.st23{fill:none;stroke:#E94B3D;stroke-width:2.1943;stroke-miterlimit:10;}\n\t.st24{fill:url(#SVGID_21_);}\n\t.st25{fill:url(#SVGID_22_);}\n\t.st26{fill:url(#SVGID_23_);}\n\t.st27{fill:url(#SVGID_24_);}\n\t.st28{fill:url(#SVGID_25_);}\n\t.st29{fill:url(#SVGID_26_);}\n\t.st30{fill:url(#SVGID_27_);}\n\t.st31{fill:url(#SVGID_28_);}\n\t.st32{fill:url(#SVGID_29_);}\n\t.st33{fill:url(#SVGID_30_);}\n\t.st34{fill:url(#SVGID_31_);}\n\t.st35{fill:url(#SVGID_32_);}\n\t.st36{fill:none;stroke:url(#SVGID_33_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st37{fill:none;stroke:url(#SVGID_34_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st38{fill:none;stroke:url(#SVGID_35_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st39{fill:none;stroke:url(#SVGID_36_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st40{fill:none;stroke:url(#SVGID_37_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st41{fill:none;stroke:url(#SVGID_38_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st42{fill:none;stroke:url(#SVGID_39_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st43{fill:none;stroke:url(#SVGID_40_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st44{fill:none;stroke:url(#SVGID_41_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st45{fill:none;stroke:url(#SVGID_42_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st46{fill:none;stroke:url(#SVGID_43_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st47{fill:url(#SVGID_44_);}\n\t.st48{fill:url(#SVGID_45_);}\n\t.st49{fill:url(#SVGID_46_);}\n\t.st50{fill:none;stroke:url(#SVGID_47_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st51{fill:none;stroke:url(#SVGID_48_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st52{fill:none;stroke:url(#SVGID_49_);stroke-width:1.528;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st53{fill:url(#SVGID_50_);}\n\t.st54{fill:url(#SVGID_51_);}\n\t.st55{fill:url(#SVGID_52_);}\n\t.st56{fill:url(#SVGID_53_);}\n\t.st57{fill:url(#SVGID_54_);}\n\t.st58{fill:url(#SVGID_55_);}\n\t.st59{fill:url(#SVGID_56_);}\n\t.st60{fill:url(#SVGID_57_);}\n\t.st61{fill:url(#SVGID_58_);}\n\t.st62{fill:none;stroke:url(#SVGID_59_);stroke-width:1.528;stroke-miterlimit:10;}\n\t.st63{fill:#FFFFFF;}\n\t.st64{fill:url(#SVGID_60_);}\n\t.st65{fill:url(#SVGID_61_);}\n\t.st66{fill:url(#SVGID_62_);}\n\t.st67{fill:url(#SVGID_63_);}\n\t.st68{fill:url(#SVGID_64_);}\n\t.st69{fill:url(#SVGID_65_);}\n\t.st70{fill:url(#SVGID_66_);}\n\t.st71{fill:url(#SVGID_67_);}\n\t.st72{fill:url(#SVGID_68_);}\n\t.st73{fill:url(#SVGID_69_);}\n\t.st74{fill:url(#SVGID_70_);}\n\t.st75{fill:url(#SVGID_71_);}\n\t.st76{fill:url(#SVGID_72_);}\n\t.st77{fill:url(#SVGID_73_);}\n\t.st78{fill:none;stroke:url(#SVGID_74_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st79{fill:none;stroke:url(#SVGID_75_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st80{fill:none;stroke:url(#SVGID_76_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st81{fill:none;stroke:url(#SVGID_77_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st82{fill:none;stroke:url(#SVGID_78_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st83{fill:none;stroke:url(#SVGID_79_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st84{fill:none;stroke:url(#SVGID_80_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st85{fill:none;stroke:url(#SVGID_81_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st86{fill:none;stroke:url(#SVGID_82_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st87{fill:none;stroke:url(#SVGID_83_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st88{fill:none;stroke:url(#SVGID_84_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st89{fill:url(#SVGID_85_);}\n\t.st90{fill:url(#SVGID_86_);}\n\t.st91{fill:url(#SVGID_87_);}\n\t.st92{fill:none;stroke:url(#SVGID_88_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st93{fill:none;stroke:url(#SVGID_89_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st94{fill:none;stroke:url(#SVGID_90_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st95{fill:url(#SVGID_91_);}\n\t.st96{fill:url(#SVGID_92_);}\n\t.st97{fill:url(#SVGID_93_);}\n\t.st98{fill:url(#SVGID_94_);}\n\t.st99{fill:url(#SVGID_95_);}\n\t.st100{fill:url(#SVGID_96_);}\n\t.st101{fill:url(#SVGID_97_);}\n\t.st102{fill:url(#SVGID_98_);}\n\t.st103{fill:url(#SVGID_99_);}\n\t.st104{fill:none;stroke:url(#SVGID_100_);stroke-width:2.0883;stroke-miterlimit:10;}\n\t.st105{clip-path:url(#SVGID_102_);}\n\t.st106{fill:url(#SVGID_103_);}\n\t.st107{fill:url(#SVGID_104_);}\n\t.st108{fill:url(#SVGID_105_);}\n\t.st109{fill:url(#SVGID_106_);}\n\t.st110{fill:url(#SVGID_107_);}\n\t.st111{fill:none;stroke:#E94B3D;stroke-width:2.3996;stroke-miterlimit:10;}\n\t.st112{fill:url(#SVGID_108_);}\n\t.st113{fill:url(#SVGID_109_);}\n\t.st114{fill:url(#SVGID_110_);}\n\t.st115{fill:url(#SVGID_111_);}\n\t.st116{fill:url(#SVGID_112_);}\n\t.st117{fill:url(#SVGID_113_);}\n\t.st118{fill:url(#SVGID_114_);}\n\t.st119{fill:url(#SVGID_115_);}\n\t.st120{fill:url(#SVGID_116_);}\n\t.st121{fill:url(#SVGID_117_);}\n\t.st122{fill:url(#SVGID_118_);}\n\t.st123{fill:url(#SVGID_119_);}\n\t.st124{fill:none;stroke:url(#SVGID_120_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st125{fill:none;stroke:url(#SVGID_121_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st126{fill:none;stroke:url(#SVGID_122_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st127{fill:none;stroke:url(#SVGID_123_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st128{fill:none;stroke:url(#SVGID_124_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st129{fill:none;stroke:url(#SVGID_125_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st130{fill:none;stroke:url(#SVGID_126_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st131{fill:none;stroke:url(#SVGID_127_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st132{fill:none;stroke:url(#SVGID_128_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st133{fill:none;stroke:url(#SVGID_129_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st134{fill:none;stroke:url(#SVGID_130_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st135{fill:url(#SVGID_131_);}\n\t.st136{fill:url(#SVGID_132_);}\n\t.st137{fill:url(#SVGID_133_);}\n\t.st138{fill:none;stroke:url(#SVGID_134_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st139{fill:none;stroke:url(#SVGID_135_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st140{fill:none;stroke:url(#SVGID_136_);stroke-width:2.0883;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st141{fill:url(#SVGID_137_);}\n\t.st142{fill:url(#SVGID_138_);}\n\t.st143{fill:url(#SVGID_139_);}\n\t.st144{fill:url(#SVGID_140_);}\n\t.st145{fill:url(#SVGID_141_);}\n\t.st146{fill:url(#SVGID_142_);}\n\t.st147{fill:url(#SVGID_143_);}\n\t.st148{fill:url(#SVGID_144_);}\n\t.st149{fill:url(#SVGID_145_);}\n\t.st150{fill:none;stroke:url(#SVGID_146_);stroke-width:2.0883;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.3745,
    y1: 46.2391,
    x2: 49.8615,
    y2: 90.7262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.13,92.62c-20.48,0-32.6-28.9-33.15-30.23c-2.36-5.86-2.58-11.08-0.64-15.55    c2.57-5.93,8.05-8.36,8.84-8.69c2.48-1.27,4.57,0.31,5.38,1.69l5.07,8.84c0.02,0.04,0.04,0.08,0.06,0.12    c1.43,3.11-0.96,6.21-1.54,6.9c-3.76,6.5,3.83,12.97,4.15,13.25c0.08,0.06,0.15,0.14,0.21,0.21c4.65,5.79,7.96,5.7,9.06,4.84    c0.05-0.04,0.14-0.11,0.2-0.14c4.3-2.5,6.9-0.55,7.54,0.04l8,5.87c0.98,0.8,1.51,1.86,1.62,3.12c0.15,1.77-0.61,3.57-2.04,4.8    c-0.88,0.76-2.17,1.72-3.35,2.5c-1.29,0.85-2.65,1.45-4.04,1.78C43.64,92.41,41.85,92.62,40.13,92.62z M16.35,40.93    c-0.05,0.02-5.07,2.04-7.27,7.14c-1.59,3.69-1.35,8.12,0.69,13.18c0.13,0.32,13.8,32.89,35.01,27.78c1.05-0.25,2.1-0.72,3.1-1.37    c1.08-0.71,2.24-1.57,3.03-2.26c0.7-0.61,1.08-1.46,1.01-2.27c-0.05-0.58-0.29-0.84-0.47-0.99l-8.01-5.87    c-0.08-0.06-0.16-0.13-0.23-0.21c-0.1-0.09-1.27-1.12-3.85,0.35c-0.45,0.33-1.81,1.17-3.94,0.99c-2.95-0.26-6.04-2.36-9.18-6.24    c-3.47-2.96-8.76-10.19-4.63-17.12c0.05-0.09,0.12-0.17,0.19-0.25c0.01-0.02,1.83-2.08,1.16-3.68l-5.02-8.76    c-0.26-0.42-0.73-0.86-1.43-0.5C16.45,40.89,16.4,40.91,16.35,40.93L16.35,40.93z M15.8,39.53L15.8,39.53L15.8,39.53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8606,
    y1: 25.4059,
    x2: 72.3666,
    y2: 63.9119
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.04,68.54c-7.96,0-13.16-3.16-14.83-4.33l-11,1.68c-0.49,0.07-0.97-0.09-1.31-0.44    c-0.34-0.35-0.49-0.85-0.4-1.33l1.75-9.3c0.16-0.87,0.09-1.78-0.2-2.62c-1.78-5.03-6.39-22.22,9.09-32.19    c0.17-0.11,0.34-0.21,0.51-0.31c2.35-1.3,14.79-7.5,29.01-1.76c0.36,0.15,0.72,0.3,1.07,0.46c0.76,0.35,1.09,1.24,0.74,2    c-0.35,0.76-1.24,1.09-2,0.74c-0.31-0.14-0.62-0.28-0.94-0.4c-13.23-5.34-25.11,0.87-26.42,1.6c-0.12,0.06-0.23,0.13-0.34,0.2    c-13.25,8.53-9.93,22.88-7.88,28.65c0.48,1.34,0.59,2.79,0.32,4.18l-1.36,7.21l9.53-1.45c0.43-0.07,0.86,0.05,1.19,0.33    c0.39,0.32,9.91,7.88,25.61,1.54c0.77-0.31,1.65,0.06,1.96,0.83c0.31,0.77-0.06,1.65-0.83,1.96    C65.31,67.82,60.86,68.54,57.04,68.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.9889,
    y1: 32.0338,
    x2: 87.9896,
    y2: 51.0345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.27,59.13c-0.34,0-0.68-0.11-0.96-0.35c-0.64-0.53-0.73-1.48-0.2-2.12c0.48-0.58,0.93-1.19,1.34-1.81    c4.84-7.3,4.69-17.16-0.39-25.1c-0.85-1.33-1.57-2.28-2.48-3.28c-0.56-0.62-0.51-1.57,0.1-2.13c0.62-0.56,1.57-0.51,2.13,0.1    c1.02,1.12,1.85,2.22,2.78,3.69c5.72,8.95,5.86,20.09,0.36,28.39c-0.47,0.71-0.99,1.41-1.53,2.07    C80.14,58.94,79.71,59.13,79.27,59.13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.7296,
    y1: 8.761,
    x2: 87.2755,
    y2: 24.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.59,25.37c-0.75,0-1.39-0.55-1.49-1.31c-0.55-4.21-2.1-7.26-4.6-9.07c-3.66-2.64-8.28-1.77-8.32-1.76    c-0.82,0.15-1.61-0.37-1.77-1.19c-0.16-0.81,0.36-1.61,1.18-1.77c0.24-0.05,5.9-1.14,10.65,2.25c3.22,2.3,5.2,6.05,5.86,11.14    c0.11,0.83-0.47,1.58-1.3,1.69C85.72,25.36,85.65,25.37,85.59,25.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.0124,
    y1: 0.7247,
    x2: 94.1727,
    y2: 22.885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.87,24.56c0,0-0.01,0-0.01,0c-0.83-0.01-1.5-0.69-1.5-1.52c0.04-5.48-1.54-9.7-4.7-12.53    C79.79,5.25,70.34,6.29,70.24,6.3c-0.83,0.1-1.58-0.49-1.67-1.32c-0.1-0.83,0.49-1.58,1.32-1.67c0.44-0.05,10.91-1.2,17.78,4.96    c3.83,3.44,5.75,8.42,5.71,14.8C93.37,23.89,92.7,24.56,91.87,24.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.6209,
    y1: 18.4135,
    x2: 77.971,
    y2: 25.7637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M74.3,27.29c-2.87,0-5.2-2.33-5.2-5.2s2.33-5.2,5.2-5.2c2.87,0,5.2,2.33,5.2,5.2S77.16,27.29,74.3,27.29z     M74.3,18.9c-1.76,0-3.19,1.43-3.19,3.19c0,1.76,1.43,3.19,3.19,3.19s3.19-1.43,3.19-3.19C77.49,20.33,76.06,18.9,74.3,18.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.244,
    y1: 36.3106,
    x2: 49.8139,
    y2: 44.8806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M42.67,37.16l2.85,8.43l2.86-8.43h2.28L46.89,47.8h-2.73L40.4,37.16H42.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.9387,
    y1: 38.5986,
    x2: 60.6546,
    y2: 46.3145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M59.5,37.7c0.81,0.46,1.45,1.11,1.91,1.94c0.47,0.83,0.7,1.77,0.7,2.81c0,1.05-0.23,1.99-0.7,2.82    s-1.11,1.48-1.91,1.94c-0.81,0.46-1.71,0.69-2.71,0.69c-1,0-1.9-0.23-2.71-0.69c-0.81-0.46-1.45-1.11-1.91-1.94    c-0.47-0.83-0.7-1.77-0.7-2.82c0-1.05,0.23-1.98,0.7-2.81c0.47-0.83,1.11-1.47,1.91-1.94c0.81-0.46,1.71-0.69,2.71-0.69    C57.79,37.01,58.69,37.24,59.5,37.7z M55.15,39.39c-0.47,0.28-0.84,0.69-1.11,1.21c-0.27,0.53-0.4,1.14-0.4,1.85    c0,0.7,0.13,1.32,0.4,1.85c0.27,0.53,0.63,0.93,1.11,1.21c0.47,0.28,1.02,0.42,1.64,0.42s1.17-0.14,1.64-0.42    c0.47-0.28,0.84-0.69,1.11-1.21c0.27-0.53,0.4-1.14,0.4-1.85c0-0.7-0.13-1.32-0.4-1.85c-0.27-0.53-0.64-0.93-1.11-1.21    s-1.02-0.42-1.64-0.42S55.63,39.11,55.15,39.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.5868,
    y1: 39.2878,
    x2: 67.9711,
    y2: 45.6721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.84,37.16V47.8h-2.13V37.16H65.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.5639,
    y1: 38.3661,
    x2: 72.9481,
    y2: 44.7503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M69.9,43.85v3.95h-2.13V37.16h3.87c1.26,0,2.2,0.3,2.84,0.9c0.64,0.6,0.96,1.42,0.96,2.46    c0,1.02-0.33,1.82-0.99,2.43c-0.66,0.6-1.59,0.9-2.81,0.9H69.9z M73.29,40.52c0-0.53-0.15-0.94-0.44-1.22    c-0.29-0.28-0.77-0.42-1.43-0.42H69.9v3.27h1.52C72.67,42.15,73.29,41.61,73.29,40.52z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.8786,
    y1: 60.1079,
    x2: 76.1526,
    y2: 62.3819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F6285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    style: {
      stopColor: "#256183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3235,
    style: {
      stopColor: "#445C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#655277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    style: {
      stopColor: "#873D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3195B"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 75.02,
    cy: 61.24,
    r: 1.61
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoip);
export default __webpack_public_path__ + "static/media/voip.ce79ad25a5dc33b38f3d93ba10850d26.svg";
export { ForwardRef as ReactComponent };